import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import CommonLayout from 'components/layout/common'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import addressesAPI from 'lib/api/address'
import Typo from 'constants/typography'
import StoreLocations from 'components/offline/store-locations'
import { PAGE_NAME } from 'pages/const'
import { POMELO_STORES_TOP_BANNER } from './const'
import styles from './style.scss'
import BasePage from '../base'

class Offline extends BasePage {
  static getInitialProps({ store, req, res, isServer }) {
    if (isServer) {
      BasePage.loadInitialContentFromServer({ req, res, store })
    } else {
      BasePage.loadInitialContentFromClient(req, res, store)
    }

    return {}
  }

  state = {
    addressLocations: [],
    selectedLocation: null,
  }

  async afterPageMount() {
    const data = {
      shop_id: this.props.internationalization.shop,
      pickup_type: 'store',
    }

    const res = await addressesAPI.getPickUpPoints(data)

    if (res?.pickup?.length > 1) {
      this.setState({
        addressLocations: res.pickup,
      })
    } else if (res.pickup?.length === 1) {
      this.setState({
        addressLocations: res.pickup,
        selectedLocation: res.pickup[0],
      })
    }
  }

  getPageMeta() {
    const { t } = this.props

    return {
      title: `${t('Have You Tried Pomelo Pick Up?')} - Pomelo Fashion`,
      description: `
        ${hasLocizeTranslation(
          t,
          'OFFLINE_HAVE_YOU_TRIED_POMELO_PICKUP',
          `Tap.Try.Buy. The only way to shop! Reserve your favorite fashion items online. Try on at a location of your choice for free. Only pay from the items you love. Never make a return again.
          ✓Free Returns ✓Weekly New Arrivals ✓Free delivery ✓Try First, Pay Later`,
        )}
      `,
    }
  }

  render() {
    const { t, isPhone } = this.props

    return (
      <CommonLayout
        meta={this.getPageMeta()}
        pageName={PAGE_NAME.offlineStore}
        showCountryModal={false}
      >
        <style jsx>{styles}</style>
        <div className="pomelo-store-container">
          <div className="PSC_top-container">
            <span className={Typo.h4}>
              {hasLocizeTranslation(
                t,
                POMELO_STORES_TOP_BANNER.keyMain,
                POMELO_STORES_TOP_BANNER.textMain,
              )}
            </span>
            <span
              className={`PSC_top-container_sub-title ${
                isPhone ? Typo.subtitle2 : Typo.subtitle1
              }`}
            >
              {hasLocizeTranslation(
                t,
                POMELO_STORES_TOP_BANNER.keySecondary,
                POMELO_STORES_TOP_BANNER.textSecondary,
              )}
            </span>
          </div>
          <StoreLocations />
        </div>
      </CommonLayout>
    )
  }
}

Offline.propTypes = {
  internationalization: PropTypes.shape({
    shop: PropTypes.number,
  }),
  isPhone: PropTypes.bool,
  t: PropTypes.func,
}

export { Offline }

const Extended = withI18next(['global'])(Offline)

export default connect(
  /* istanbul ignore next */
  (state) => ({
    internationalization: state.internationalization,
    isPhone: state.device.isPhone,
  }),
)(Extended)
